import { BaseService } from 'core/services';
import TaskCommentNotificationRouteService from './TaskCommentNotificationRouteService';

class TaskCommentNotificationService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TaskCommentNotificationRouteService());
    }
    async count(userId){
        const url = this.routeService.count(userId);
        return this.apiClient.get(url);
    }
}

export default TaskCommentNotificationService;
